import React from "react"
import LogoAolIdeas from "../../images/logos-partners/logo-aol-ideas.png"
import LogoBandCoders from "../../images/logos-partners/logo-band-of-coders.png"
import LogoGlobalHints from "../../images/logos-partners/logo-global-hints.png"
import LogoIntiveFdv from "../../images/logos-partners/logo-intive-fdv.png"
import LogoJampp from "../../images/logos-partners/logo-jampp.png"
import LogoMakingSense from "../../images/logos-partners/logo-making-sense.png"
import LogoMarianne from "../../images/logos-partners/logo-marianne.png"
import LogoN5 from "../../images/logos-partners/logo-n5.png"
import LogoRappi from "../../images/logos-partners/logo-rappi.png"
import LogoRokkerlabs from "../../images/logos-partners/logo-rokkerlabs.png"
import LogoTangeloGames from "../../images/logos-partners/logo-tangelo-games.png"
import LogoTheElectricFactory from "../../images/logos-partners/logo-the-electric-factory.png"
import LogoW3 from "../../images/logos-partners/logo-w3.png"
import LogoWolox from "../../images/logos-partners/logo-wolox.png"

const PartnersList = () => {
  return (
    <section className="container mx-auto px-6 py-12">
      <h3 className="text-5xl pb-8 font-normal leading-tight text-center">
        <span className="text-secondary block font-bold">Our</span> partners
      </h3>
      <p className="w-full md:w-1/2 pb-12 text-center mx-auto text-lg"><b>Renowned companies around the world are part of our ally network.</b> We have more than 30 Partners who rely on us for software development.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8 lg:gap-4 justify-items-center">
        <div className="self-center"><img src={LogoAolIdeas} alt="Aol Ideas" /></div>
        <div className="self-center"><img src={LogoBandCoders} alt="Band of Coders" /></div>
        <div className="self-center"><img src={LogoGlobalHints} alt="Global Hints" /></div>
        <div className="self-center"><img src={LogoIntiveFdv} alt="Intive Fdv" /></div>
        <div className="self-center"><img src={LogoJampp} alt="Jampp" /></div>
        <div className="self-center"><img src={LogoMakingSense} alt="Making Sense" /></div>
        <div className="self-center"><img src={LogoMarianne} alt="Marianne" /></div>
        <div className="self-center"><img src={LogoN5} alt="N5" /></div>
        <div className="self-center"><img src={LogoRappi} alt="Rappi" /></div>
        <div className="self-center"><img src={LogoRokkerlabs} alt="Rokker labs" /></div>
        <div className="self-center"><img src={LogoTangeloGames} alt="Tangelo Games" /></div>
        <div><img src={LogoTheElectricFactory} alt="The Electric Factory" /></div>
        <div className="self-center"><img src={LogoW3} alt="W3" /></div>
        <div className="self-center"><img src={LogoWolox} alt="Wolox" /></div>      
      </div>
    </section>
  )
}

export default PartnersList
